import { App } from '@capacitor/app';
import { isNativePlatform } from 'services/auth/platform';

export const isOffline = (): boolean => typeof navigator !== 'undefined' && !navigator.onLine;

export const onResumeOrReconnect = (callback: () => void): (() => void) => {
  const teardown: (() => void)[] = [];

  if (isNativePlatform()) {
    const handle = App.addListener('appStateChange', ({ isActive }) => {
      if (isActive) callback();
    });
    teardown.push(() => void handle.then((listener) => listener.remove()));
  } else {
    const onVisible = () => {
      if (document.visibilityState === 'visible') callback();
    };
    document.addEventListener('visibilitychange', onVisible);
    teardown.push(() => document.removeEventListener('visibilitychange', onVisible));
  }

  window.addEventListener('online', callback);
  teardown.push(() => window.removeEventListener('online', callback));

  return () => teardown.forEach((remove) => remove());
};
